<template>
  <div class="answer-card">
    <div class="exam-title" v-if="isExam">
      <h1 class="title" v-if="title">{{title}}</h1>
      <h2><span class="score">{{score}}</span>分</h2>
      <h3 class="exam-hint" v-if="isShowHint">点击题目编号即可查看作答情况哦</h3>
      <p class="tagline" v-if="showTagline">
        <template v-if="score >= 100">
          你真棒！继续保持哦！
        </template>
        <template v-else>
          做错的题在错题本等你复习呦！点击红色题目编号可查看错题及解析。
        </template>
      </p>
      <br />
    </div>
    <div v-else>
      <h1>答题卡</h1>
      <h3><span v-if="isAllComplete">还有题目未作答，</span>点击题目编号可以答题/改答案，检查好了再交卷哦！</h3>
    </div>
    <div class="detail" v-if="showDetail">
      <span class="number"
            :class="{
              filled: answer.isComplete && !isExam,
              success: answer.isRight,
              danger: answer.isWrong,
            }"
            v-for="(answer, index) in answerResults"
            :key="index"
            @click="$emit('to', index)">{{index + 1}}</span>
    </div>
    <slot name="detail"></slot>
  </div>
</template>

<script>
// import utils from '@/services/utils';

export default {
  props: {
    total: {
      type: Number,
      require: true,
    },
    isShowHint: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Array,
      default: () => [],
    },
    score: {
      type: Number,
      default: 0,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    showDetail: {
      type: Boolean,
      default: true,
    },
    showTagline: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    answerResults() {
      const results = [];
      for (let i = 0; i < this.total; i += 1) {
        const { answer, isRight, isComplete } = this.results[i] || { answer: '' };
        const isRight2 = this.isExam ? isRight : false;
        const isWrong = this.isExam ? !isRight : false;
        results.push({
          answer,
          isComplete,
          isRight: isRight2,
          isWrong,
        });
      }
      return results;
    },
    isAllComplete() {
      return this.answerResults.some(item => !item.isComplete);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .answer-card {
    position: absolute;
    background: #fff;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    overflow-y: auto;
    .exam-title {
      overflow: hidden;
      .exam-hint {
        margin-top: -10px;
        color: $primary;
      }
    }
    .title {
      margin-top: 60px;
    }
    .score {
      font-size: 100px;
      color: $primary;
      margin: 0 20px;
    }
    .tagline {
      color: #999;
    }
    .detail {
      padding: 20px 40px;
      display: flex;
      flex-wrap: wrap;
      .number {
        cursor: pointer;
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 10px;
        font-weight: bold;
        border-radius: 50%;
        color: $primary;
        border: 1px solid $primary;
        &.danger {
          color: #fff;
          background-color: $danger;
          border: 1px solid $danger;
        }
        &.filled {
          color: #fff;
          background-color: $primary;
        }
        &.success {
          color: #333;
          background-color: #b8dfff;
          border: 1px solid #b8dfff;
        }
      }
    }
  }
</style>
